import { assignInlineVars } from '@vanilla-extract/dynamic'
import { tokens } from 'ui/src/theme/tokens.css'
import { dots, dot, dotsColor } from './LoadingDots.css'

type Props = {
  color?: string
  /**
   * Accessible label for the loading indicator.
   * @default "Loading"
   */
  label?: string
}

export function LoadingDots({ color = tokens.colors.text.opaque.primary, label = 'Loading' }: Props) {
  return (
    <div
      style={assignInlineVars({ [dotsColor]: color })}
      className={dots}
      role="status"
      aria-label={label}
      aria-live="polite"
    >
      <span className={dot} />
      <span className={dot} />
      <span className={dot} />
    </div>
  )
}
